import { giphyBlack } from '@giphy/js-brand'
import styled from 'styled-components'
import { IconButton } from 'ui'

export const Container = styled.div`
    background: ${giphyBlack};
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px;
    position: sticky;
    top: 14px;
    width: 70px;
`

export const Button = styled(IconButton)`
    display: block;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
`
